import {
  makePost,
  makeGet,
  makeDelete,
  makePut,
  makeGetWithoutToken
} from './ServiceManager';

export const generateIframeForAccount = async (parameters) => {
  const result = await makePost('insights/iframe/', parameters);
  return result;
};

export const getIframe = async (url, customHeaders) => {
  const result = await makeGetWithoutToken(
    'insights/iframe',
    null,
    url,
    customHeaders
  );

  return result;
};

export const getIframes = async () => {
  const result = await makeGet('service/insights/iframes');
  return result;
};

export const insertIframe = async (iframeData) => {
  const result = await makePost('service/insights/iframe', iframeData);
  return result;
};

export const removeIframe = async (id) => {
  const result = await makeDelete('service/insights/iframe', { id });
  return result;
};

export const updateIframe = async (iframe) => {
  const result = await makePut('service/insights/iframe', { iframe });
  return result;
};

export const getLookerAccounts = async () => {
  let lookerAccounts = window.sessionStorage.getItem('lookerAccounts');

  if (lookerAccounts) {
    return JSON.parse(lookerAccounts);
  }

  lookerAccounts = [];

  const result = await makeGet('insights/accounts');

  if (result.statusCode === 200) {
    lookerAccounts = result.accounts;
    window.sessionStorage.setItem(
      'lookerAccounts',
      JSON.stringify(lookerAccounts)
    );
    return lookerAccounts;
  }

  return lookerAccounts;
};

export const refreshLookerAccounts = async () => {
  window.sessionStorage.removeItem('lookerAccounts');

  let lookerAccounts = window.sessionStorage.getItem('lookerAccounts');

  if (lookerAccounts) {
    return JSON.parse(lookerAccounts);
  }

  lookerAccounts = [];

  const result = await makeGet('insights/accounts');

  if (result.statusCode === 200) {
    lookerAccounts = result.accounts;
    window.sessionStorage.setItem(
      'lookerAccounts',
      JSON.stringify(lookerAccounts)
    );
    return lookerAccounts;
  }

  return lookerAccounts;
};

export const getLookerFilters = async () => {
  let lookerFilters = window.sessionStorage.getItem('lookerFilters');

  if (lookerFilters) {
    return JSON.parse(lookerFilters);
  }

  lookerFilters = [];

  const result = await makeGet('insights/filters');

  if (result.statusCode === 200) {
    lookerFilters = result.filters;
    window.sessionStorage.setItem(
      'lookerFilters',
      JSON.stringify(lookerFilters)
    );
    return lookerFilters;
  }

  return lookerFilters;
};

export const refreshLookerFilters = async () => {
  window.sessionStorage.removeItem('lookerFilters');

  let lookerFilters = window.sessionStorage.getItem('lookerFilters');

  if (lookerFilters) {
    return JSON.parse(lookerFilters);
  }

  lookerFilters = [];

  const result = await makeGet('insights/filters');

  if (result.statusCode === 200) {
    lookerFilters = result.filters;
    window.sessionStorage.setItem(
      'lookerAccounts',
      JSON.stringify(lookerFilters)
    );
    return lookerFilters;
  }

  return lookerFilters;
};



// WEBPACK FOOTER //
// ./src/services/InsightsPreviewManager.js